import React from 'react'
import styled from 'styled-components'
import { Skeleton } from './Skeleton'
import { Table, TableRow, TableHeadCell, TableCell } from './Table'

type Props = {
    rowCount?: number
    columnCount?: number
    columnSize?: string
    rowSize?: string
    className?: string
}

export const TableSkeleton = (props: Props): JSX.Element => {
    const { rowCount = 10, columnCount = 5, columnSize, rowSize, className } = props

    const Headers = new Array(columnCount)
        .fill(null)
        .map((_, index) => `col_${index}`)
        .map((key) => (
            <TableHeadCell key={key}>
                <Skeleton lineHeight="sub" />
            </TableHeadCell>
        ))
    const Rows = new Array(columnCount)
        .fill(null)
        .map((_, index) => `col_${index}`)
        .map((key) => (
            <TableCell key={key}>
                <Container>
                    <Skeleton fontSize="sub" />
                </Container>
            </TableCell>
        ))
    return (
        <StyledTable className={className}>
            <TableRow columnSize={columnSize || `repeat(${columnCount}, 1fr)`}>{Headers}</TableRow>
            {new Array(rowCount)
                .fill(null)
                .map((_, index) => `col_${index}`)
                .map((key) => (
                    <TableRow
                        key={key}
                        columnSize={columnSize || `repeat(${columnCount}, 1fr)`}
                        rowSize={rowSize}
                    >
                        {Rows}
                    </TableRow>
                ))}
        </StyledTable>
    )
}

const Container = styled.div`
    display: flex;
    flex-flow: column nowrap;
    min-width: 0px;
    flex: 1 1 auto;
`

const StyledTable = styled(Table)`
    min-height: 0;
    min-width: 0;
`
